/*@flow*/
/** @jsx jsx */
// @ts-check
import { jsx, css } from '@emotion/core';
import { useEffect } from 'react';
import waitTill from 'lib/waitTill';
import { useHide } from './useHide';

export function MapContainer({ children }) {
  const hide = useHide();
  return (
    <div
      className="map-container"
      css={css(`
          display: grid;
          grid-template-columns: 70px 1fr ${hide ? '' : '285px'};
          @media(max-width: 775px) {
            grid-template-columns: 44px 1fr;
          }
          background: #f2f6f9;
          height: 100%;
      `)}
    >
      {children}
    </div>
  );
}
